import {inject, Injectable} from '@angular/core';
import {FileParams, FileTypeName} from "../../../../types/file.types";
import {PreviewFilesStateService} from "../../../../services/preview-files-state.service";
import {PreviewFileUrlsStateService} from "../../../../services/preview-file-urls-state.service";

@Injectable({
  providedIn: 'root'
})
export class FeedbackMediaModalService {
  private previewFilesStateService: PreviewFilesStateService = inject(PreviewFilesStateService);
  private previewFileUrlsStateService: PreviewFileUrlsStateService = inject(PreviewFileUrlsStateService);

  public setImageUrlsToState(photoLinks: Array<string> | null): void {
    if (!photoLinks) { return; }

    const filesArray: Array<FileParams> = [];
    photoLinks.forEach((url, index) => {
      this.previewFilesStateService.updatePreviewFilesState(index + 1, url);
      filesArray.push({
        id: index + 1,
        filename: url,
        size: url.length
      });
    });

    const fileUrls = { 'FEEDBACK': filesArray } as Record<FileTypeName, Array<FileParams>>;
    this.previewFileUrlsStateService.setPreviewFileUrlsState(fileUrls);
  }
}
